<div class="pk" (keydown)="onKey($event)">
  <button type="button" class="pk-nav prev" aria-label="Mois précédent" title="Mois précédent" (click)="shift(-1)">‹</button>
  <button type="button" class="pk-nav next" aria-label="Mois suivant" title="Mois suivant" (click)="shift(1)">›</button>
  @for (m of months; track m.first) {
    <div class="pk-mo">
      <h4>{{ m.title }}</h4>
      <div class="pk-grid">
        @for (w of weekdays; track w) {
          <div class="pk-dow" aria-hidden="true">{{ w }}</div>
        }
        @for (b of m.blanks; track b) {
          <div aria-hidden="true"></div>
        }
        @for (c of m.cells; track c.d) {
          <button type="button" [class]="c.cls" [attr.data-day]="c.d" [disabled]="c.disabled" [attr.tabindex]="c.tab" [attr.aria-label]="c.aria" [attr.aria-pressed]="c.pressed" [attr.aria-current]="c.today ? 'date' : null" [title]="c.tip" (click)="select(c.d)">
            @if (c.lock) {
              <span class="lk" aria-hidden="true">🔒</span>
            }
            @if (c.dot) {
              <span class="dot" aria-hidden="true"></span>
            }
            <span class="num">{{ c.num }}</span>
          </button>
        }
      </div>
    </div>
  }
</div>
